import { getEmailValidator, getNameValidator, getUSPhoneNumberValidator } from 'validators';
import { getTestIds } from 'seagull/utils/TestIds';
export const buildContactValidators = (messages)=>({
        firstName: getNameValidator('First name', messages.firstNameRequiredError),
        lastName: getNameValidator('Last name', messages.lastNameRequiredError),
        email: getEmailValidator(messages.emailInvalidError, messages.emailInvalidError),
        phone: (value)=>{
            const result = getUSPhoneNumberValidator(false)(value);
            return result === true ? true : messages.phoneInvalidError;
        }
    });
export const normalizeContactPhone = (phone)=>(phone === null || phone === void 0 ? void 0 : phone.trim()) ? phone : undefined;
export const CONTACT_FORM_DEFAULTS = {
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
};
export const GetContactFormTID = (parentTestId)=>getTestIds(parentTestId);
